import React, {Component} from "react";
import PropTypes from "prop-types";

export default class AutoTextarea extends Component {
  static propTypes = {
    children: PropTypes.any,
    onChange: PropTypes.func,
    style: PropTypes.object,
    value: PropTypes.string,
  }

  componentDidMount() {
    this.recalculateSize();
  }

  handleChange = (evt) => {
    if (this.props.onChange) {
      this.props.onChange(evt);
    }
    this.recalculateSize();
  }

  recalculateSize() {
    const node = this.textareaEl;
    let diff;

    if (window.getComputedStyle) {
      const styles = window.getComputedStyle(node);
      if (styles.getPropertyValue("box-sizing") === "border-box" ||
        styles.getPropertyValue("-moz-box-sizing") === "border-box" ||
        styles.getPropertyValue("-webkit-box-sizing") === "border-box") {
        diff = 0;
      } else {
        diff = parseInt(styles.getPropertyValue("padding-bottom") || 0, 10) +
          parseInt(styles.getPropertyValue("padding-top") || 0, 10);
      }
    } else {
      diff = 0;
    }

    node.style.height = "auto";
    node.style.height = `${node.scrollHeight - diff}px`;
  }

  includeUrls = (text) => {
    return text.match(/http:|https:|www\.|\.com|\.org|\.edu|\.gov|\.uk|\.net|\.ca|\.de|\.jp|\.fr|\.au|\.us|\.io/g);
  }

  render() {
    const props = {
      ...this.props,
      onChange: this.handleChange,
      ref: (el) => this.textareaEl = el,
      style: {
        ...this.props.style,
        overflow: "hidden",
      },
      value: this.props.value || "",
    };
    const textArea = React.DOM.textarea(props, this.props.children);
    return (
      <div>
        {textArea}
        {this.includeUrls(this.props.value || "") &&
          <small className="pull-right text-warning">
            Your text might include urls, please make sure they are valid.
          </small>}
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/components/shared/AutoTextarea.js
 **/